define('native/Messages',[],function () {

    return function (nativeLayerMessenger, imageOptimizer, messageChannels) {

        this.loginError = function () {

            nativeLayerMessenger.sendMessage(messageChannels.LOGIN_ERROR);
        };

        this.playerLogin = function (loginData) {

            var playerData = {
                id: loginData.player.id,
                level: loginData.player.adventurer.getAdventure().humanReadableLevel() || 0,
                marketCode: loginData.player.market().code,
                username: loginData.credentials.username,
                password: loginData.credentials.password
            };

            nativeLayerMessenger.sendMessage(messageChannels.PLAYER_LOGIN, playerData);
        };

        this.appLoaded = function () {
            window.native = window.native || {};
            window.native.loaded = true;
            nativeLayerMessenger.sendMessage(messageChannels.APP_LOADED);
        };

        this.launchGame = function (model, game, isPractice) {

            nativeLayerMessenger.sendMessage(messageChannels.LAUNCH_GAME, {
                id: game.slug,
                name: game.name(),
                url: model.gameUrl,
                provider: model.providerType,
                isPractice: isPractice,
                thumbnail: game.thumbnail(),
                logo: game.logo(),
                icon: imageOptimizer.getOptimizedUrl(game.thumbnail(), {
                    fm: 'png',
                    mask: 'ellipse',
                    markscale: 100,
                    fit: 'crop',
                    crop: 'top',
                    w: 160,
                    h: 160,
                    markalign: 'top center',
                    mark: game.logo()
                })
            },
            function () {
                // Fallback to normal game opening if we fail to send the message
                window.location = model.gameUrl;
            });
        };
    };
});

